var map = {
	"./0-star.svg": 972,
	"./1-star.svg": 973,
	"./2-star.svg": 974,
	"./3-star.svg": 975,
	"./4-star.svg": 976,
	"./5-star.svg": 977
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 647;



//////////////////
// WEBPACK FOOTER
// ./src/client/images ^\.\/.*\-star\.svg$
// module id = 647
// module chunks = 0